import axios from 'axios'

const client = axios.create({
    baseURL: '/api/AutorizarAsociado',
    json: true
})

export default {
    async execute(vue, method, resource, data) {
        return client({
            method,
            url: resource,
            data
        }).then(req => {
            if (req.data.error) {
                vue.$alert(req.data.error).then(() => {
                    //PBI 247029 - Fanaia.Autoservicio.Web - Cross-Site Scripting DOM
                    //Fortify Software Security Center
                    //Cross-Site Scripting DOM
                    //Cross-Site Scripting: Poor Validation
                    //Soluci�n preventiva
                    //Se soluciona Cross-Site Scripting DOM y se genera una Cross-Site Scripting: Poor Validation que se soluciona preventivamente
                    var pattern = /^(https?|ftp)::\/\/[^\s/$.?#].[^\s]*$/i;
                    if (pattern.test(window.location.protocol + "//" + window.location.host + "/index.html#/"))
                        document.location = encodeURIComponent(window.location.protocol + "//" + window.location.host + "/index.html#/");
                });
            }
            return req.data
        })
    },
    get(vue, id) {
        return this.execute(vue, 'get', `Get/${id}`)
    },
    post(vue, data) {
        return this.execute(vue, 'post', 'Post/', data)
    }
}
